import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	settingsLink: {
		id: 'software-code-code-page.common.more-menu.settings-link',
		defaultMessage: 'Manage project features',
		description:
			'The title of the "Manage project features" link in the "More" menu of the "Code" page. This link takes the user to the project features page where they can configure the "Code" feature.',
	},
	manageBitbucketAccountsLink: {
		id: 'software-code-code-page.common.more-menu.manage-bitbucket-accounts-link',
		defaultMessage: 'Manage Bitbucket accounts',
		description:
			'The title of the "Manage Bitbucket account" link in the "More" menu of the "Code" page. This link takes the user to DVCS Accounts page and it is shown only if there is at least one Bitbucket account connected',
	},
	thirdPartyProviderSettingsLink: {
		id: 'software-code-code-page.common.more-menu.third-party-provider-settings-link',
		defaultMessage: '{providerName} settings',
		description:
			"The title of the third party provider settings page link in the 'More' menu of the 'Code' page. This link takes the user to a 'Manage apps' in Jira where the user can configure or remove their third party apps",
	},
	graphButtonLabelNonFinal: {
		id: 'software-code-code-page.common.more-menu.graph-button-label-non-final',
		defaultMessage: 'Open the graph',
		description:
			"The title of the 'Open the graph' button in the 'More' menu of the 'Code' page. Explains to the user what will happen when they click on the graph button",
	},
	leaveFeedback: {
		defaultMessage: 'Give feedback',
		id: 'software-code-code-page.common.more-menu.leave-feedback',
		description:
			"The title of the 'Give feedback' button in the 'More' menu of the 'Code' page. The button allows users to give feedback",
	},
});
